import parse from 'html-react-parser';

// Import components
import { Checkbox } from 'components/views/offer_configurator/components/common';

// Import styles
import { AgreementsList, AgreementsWrapper } from './styles';

// Import hooks
import { useUserAgreements } from 'components/utilities';

// Import helpers
import { INVOICE_AGREEMENTS } from 'helpers/agreements';

// Import types
import type { AgreementsType } from 'types/api/agreements';

type Props = {
	agreements: AgreementsType;
};

export const InvoiceModalAgreements = ({ agreements }: Props) => {
	const { confirmedAgreements, isLoading, handleAgreementChange } = useUserAgreements(INVOICE_AGREEMENTS);

	return (
		<AgreementsWrapper>
			<AgreementsList>
				{agreements.map(({ version, obligatory, id }) => {
					const label = version.description && parse(version.description);

					return (
						<Checkbox
							disabled={isLoading}
							key={id}
							checked={confirmedAgreements.includes(version.id)}
							onChange={handleAgreementChange}
							required={obligatory}
							value={version.id}
							name={`agreements_${version.id}`}
							label={label}
							isError={obligatory && !confirmedAgreements.includes(version.id)}
							modifiers="small"
						/>
					);
				})}
			</AgreementsList>
		</AgreementsWrapper>
	);
};
